<!-- <button
  (click)="salvaSuServer()"
  class="btn" style="color:rgba(0, 85, 159, 1)">
  <i class="bi bi-cloud-download-fill"></i>
  Salva su {{(isOnline$ | async) ? 'Server' : 'PC'}}
</button> -->

<div *ngIf="isOnline$ | async"class="connessione auto">
    prossimo salvataggio tra <span class="fw-bold">{{counterTxt}}</span>
</div>

<button
    *ngIf="isOnline$ | async"
    (click)="salvaSuServer()"
    class="btn btn-primary m-1">
    <i class="bi bi-cloud-upload-fill"></i>

    Salva su Server&nbsp;|
    <div *ngIf="isCurrentlySaving" class="spinner-border text-primary autosave-spinner"></div>
    <i [class.opacity-50]="isCurrentlySaving" *ngIf="(lastSave$ | async) > 0; else noLastSave">
        Ultimo salvataggio: {{lastSave$ | async | date: 'dd/MM/yyyy'}} alle {{lastSave$ | async | date: 'HH:mm:ss'}}
    </i>
    <ng-template #noLastSave>
        <i>Ultimo salvataggio: nessuno</i>
    </ng-template>
</button>

<button
    (click)="salvaSuPc()"
    class="btn btn-primary m-1">
    <i class="bi bi-cloud-download-fill"></i>
    Salva su PC
</button>

<ngx-smart-modal #myModal identifier="myModal">
    <div class="modal-header">
        <h5 class="modal-title">Modale di sovrascrizione</h5>
    </div>
    <div class="modal-body">
        <p>Testo</p>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary">Sovrascrivi</button>
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Continua</button>
    </div>
</ngx-smart-modal>

